/**
 * Transcription Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.1.21
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateTranscriptionContentRequest } from '../model/createTranscriptionContentRequest';
import { CreateTranscriptionRequest } from '../model/createTranscriptionRequest';
import { DeleteTranscriptionsRequest } from '../model/deleteTranscriptionsRequest';
import { ExportTranscriptionRequest } from '../model/exportTranscriptionRequest';
import { FindAndReplaceRequest } from '../model/findAndReplaceRequest';
import { ManagementAutoTagTranscriptionsRequest } from '../model/managementAutoTagTranscriptionsRequest';
import { ManagementTranscriptionFilterRequest } from '../model/managementTranscriptionFilterRequest';
import { ManagementTranscriptionsTagRequest } from '../model/managementTranscriptionsTagRequest';
import { PageTranscriptionResponse } from '../model/pageTranscriptionResponse';
import { TranscriptionContentResponse } from '../model/transcriptionContentResponse';
import { TranscriptionResponse } from '../model/transcriptionResponse';
import { UpdateTranscriptionContentRequest } from '../model/updateTranscriptionContentRequest';
import { UpdateTranscriptionRequest } from '../model/updateTranscriptionRequest';
import { YoutubeSubtitlesResponse } from '../model/youtubeSubtitlesResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ManagementTranscriptionControllerService {

    protected basePath = 'https://transcription.sette.com.mk';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addTranscriptionsTags(body: ManagementTranscriptionsTagRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public addTranscriptionsTags(body: ManagementTranscriptionsTagRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public addTranscriptionsTags(body: ManagementTranscriptionsTagRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public addTranscriptionsTags(body: ManagementTranscriptionsTagRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addTranscriptionsTags.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/v1/management/transcriptions/tags`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public autoTagTranscriptions(body: ManagementAutoTagTranscriptionsRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public autoTagTranscriptions(body: ManagementAutoTagTranscriptionsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public autoTagTranscriptions(body: ManagementAutoTagTranscriptionsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public autoTagTranscriptions(body: ManagementAutoTagTranscriptionsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling autoTagTranscriptions.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/v1/management/transcriptions/auto-tag`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param url
     * @param lang
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkYoutubeSubtitles(url: string, lang: 'MK' | 'EN' | 'AL', observe?: 'body', reportProgress?: boolean): Observable<YoutubeSubtitlesResponse>;
    public checkYoutubeSubtitles(url: string, lang: 'MK' | 'EN' | 'AL', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<YoutubeSubtitlesResponse>>;
    public checkYoutubeSubtitles(url: string, lang: 'MK' | 'EN' | 'AL', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<YoutubeSubtitlesResponse>>;
    public checkYoutubeSubtitles(url: string, lang: 'MK' | 'EN' | 'AL', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (url === null || url === undefined) {
            throw new Error('Required parameter url was null or undefined when calling checkYoutubeSubtitles.');
        }

        if (lang === null || lang === undefined) {
            throw new Error('Required parameter lang was null or undefined when calling checkYoutubeSubtitles.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (url !== undefined && url !== null) {
            queryParameters = queryParameters.set('url', <any>url);
        }
        if (lang !== undefined && lang !== null) {
            queryParameters = queryParameters.set('lang', <any>lang);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<YoutubeSubtitlesResponse>('get',`${this.basePath}/v1/management/transcriptions/youtube-subtitles`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createMgmtTranscription(body: CreateTranscriptionRequest, observe?: 'body', reportProgress?: boolean): Observable<TranscriptionResponse>;
    public createMgmtTranscription(body: CreateTranscriptionRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TranscriptionResponse>>;
    public createMgmtTranscription(body: CreateTranscriptionRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TranscriptionResponse>>;
    public createMgmtTranscription(body: CreateTranscriptionRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createMgmtTranscription.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TranscriptionResponse>('post',`${this.basePath}/v1/management/transcriptions`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createMgmtTranscriptionContent(body: CreateTranscriptionContentRequest, observe?: 'body', reportProgress?: boolean): Observable<Array<TranscriptionContentResponse>>;
    public createMgmtTranscriptionContent(body: CreateTranscriptionContentRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TranscriptionContentResponse>>>;
    public createMgmtTranscriptionContent(body: CreateTranscriptionContentRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TranscriptionContentResponse>>>;
    public createMgmtTranscriptionContent(body: CreateTranscriptionContentRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createMgmtTranscriptionContent.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<TranscriptionContentResponse>>('post',`${this.basePath}/v1/management/transcriptions/content`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param contentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteMgmtTranscriptionContent(contentId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteMgmtTranscriptionContent(contentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteMgmtTranscriptionContent(contentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteMgmtTranscriptionContent(contentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (contentId === null || contentId === undefined) {
            throw new Error('Required parameter contentId was null or undefined when calling deleteMgmtTranscriptionContent.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/management/transcriptions/content/${encodeURIComponent(String(contentId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteMgmtTranscriptions(body: DeleteTranscriptionsRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteMgmtTranscriptions(body: DeleteTranscriptionsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteMgmtTranscriptions(body: DeleteTranscriptionsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteMgmtTranscriptions(body: DeleteTranscriptionsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling deleteMgmtTranscriptions.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/management/transcriptions`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportMgmtTranscription(body: ExportTranscriptionRequest, id: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public exportMgmtTranscription(body: ExportTranscriptionRequest, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public exportMgmtTranscription(body: ExportTranscriptionRequest, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public exportMgmtTranscription(body: ExportTranscriptionRequest, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling exportMgmtTranscription.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling exportMgmtTranscription.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<string>>('post',`${this.basePath}/v1/management/transcriptions/${encodeURIComponent(String(id))}/export`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findAndReplaceMgmtTranscriptionContent(body: FindAndReplaceRequest, id: string, observe?: 'body', reportProgress?: boolean): Observable<TranscriptionResponse>;
    public findAndReplaceMgmtTranscriptionContent(body: FindAndReplaceRequest, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TranscriptionResponse>>;
    public findAndReplaceMgmtTranscriptionContent(body: FindAndReplaceRequest, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TranscriptionResponse>>;
    public findAndReplaceMgmtTranscriptionContent(body: FindAndReplaceRequest, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling findAndReplaceMgmtTranscriptionContent.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling findAndReplaceMgmtTranscriptionContent.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TranscriptionResponse>('put',`${this.basePath}/v1/management/transcriptions/${encodeURIComponent(String(id))}/find-and-replace`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMgmtTranscriptionById(id: string, observe?: 'body', reportProgress?: boolean): Observable<TranscriptionResponse>;
    public getMgmtTranscriptionById(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TranscriptionResponse>>;
    public getMgmtTranscriptionById(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TranscriptionResponse>>;
    public getMgmtTranscriptionById(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getMgmtTranscriptionById.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TranscriptionResponse>('get',`${this.basePath}/v1/management/transcriptions/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param page 
     * @param size 
     * @param sort 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMgmtTranscriptionsPageableFilter(body: ManagementTranscriptionFilterRequest, page?: number, size?: number, sort?: string, observe?: 'body', reportProgress?: boolean): Observable<PageTranscriptionResponse>;
    public getMgmtTranscriptionsPageableFilter(body: ManagementTranscriptionFilterRequest, page?: number, size?: number, sort?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageTranscriptionResponse>>;
    public getMgmtTranscriptionsPageableFilter(body: ManagementTranscriptionFilterRequest, page?: number, size?: number, sort?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageTranscriptionResponse>>;
    public getMgmtTranscriptionsPageableFilter(body: ManagementTranscriptionFilterRequest, page?: number, size?: number, sort?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getMgmtTranscriptionsPageableFilter.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PageTranscriptionResponse>('post',`${this.basePath}/v1/management/transcriptions/filter/pageable`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeTranscriptionsTags(body: ManagementTranscriptionsTagRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public removeTranscriptionsTags(body: ManagementTranscriptionsTagRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public removeTranscriptionsTags(body: ManagementTranscriptionsTagRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public removeTranscriptionsTags(body: ManagementTranscriptionsTagRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling removeTranscriptionsTags.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/management/transcriptions/tags`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateMgmtTranscription(body: UpdateTranscriptionRequest, id: string, observe?: 'body', reportProgress?: boolean): Observable<TranscriptionResponse>;
    public updateMgmtTranscription(body: UpdateTranscriptionRequest, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TranscriptionResponse>>;
    public updateMgmtTranscription(body: UpdateTranscriptionRequest, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TranscriptionResponse>>;
    public updateMgmtTranscription(body: UpdateTranscriptionRequest, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateMgmtTranscription.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateMgmtTranscription.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TranscriptionResponse>('put',`${this.basePath}/v1/management/transcriptions/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param contentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateMgmtTranscriptionContent(body: UpdateTranscriptionContentRequest, contentId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<TranscriptionContentResponse>>;
    public updateMgmtTranscriptionContent(body: UpdateTranscriptionContentRequest, contentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TranscriptionContentResponse>>>;
    public updateMgmtTranscriptionContent(body: UpdateTranscriptionContentRequest, contentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TranscriptionContentResponse>>>;
    public updateMgmtTranscriptionContent(body: UpdateTranscriptionContentRequest, contentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateMgmtTranscriptionContent.');
        }

        if (contentId === null || contentId === undefined) {
            throw new Error('Required parameter contentId was null or undefined when calling updateMgmtTranscriptionContent.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<TranscriptionContentResponse>>('put',`${this.basePath}/v1/management/transcriptions/content/${encodeURIComponent(String(contentId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
